import { socialLinks } from '@/features/shared/constants/socialLinks'
import { type FooterData } from '@/features/shared/components/Footers/types'
import { LEGAL_LINKS, type PrivacyLinks } from '@/features/shared/constants/legalLinks'
import { PrivacyIcon } from '@/features/shared/components/Footers/PrivacyIcon'

export const getFooterPrivacyLinks = (privacyLinks: PrivacyLinks): FooterData['privacy'] => [
  {
    url: LEGAL_LINKS.TERMS_OF_SERVICE,
    name: 'Terms of service',
  },
  {
    url: privacyLinks.privacyNotice,
    name: 'Privacy',
  },
  {
    url: privacyLinks.yourPrivacyChoices,
    name: 'Your privacy choices',
    icon: PrivacyIcon,
  },
  {
    url: privacyLinks.healthDataPrivacy,
    name: 'Health Data Privacy',
  },
]

export const footerSocialLinks = [
  {
    url: socialLinks.FACEBOOK,
    name: 'facebook',
    opensInNewTab: true,
  },
  {
    url: socialLinks.INSTAGRAM,
    name: 'instagram',
    opensInNewTab: true,
  },
  {
    url: socialLinks.PINTEREST,
    name: 'pinterest',
    opensInNewTab: true,
  },
  {
    url: socialLinks.TWITTER,
    name: 'twitter',
    opensInNewTab: true,
  },
] as const
